import React, {useCallback, useMemo} from "react";
import "./index.scss";
import {oneOf} from "prop-types";
import {connect} from "react-redux";
import Title from "features/components/title";
import Text from "features/components/text";
import {historyObject} from "historyObject";
import {favoritePeopleStart} from "store/reducer/people/favorite/reducer";
import {FavoriteButton} from "features/components/favorite-btn";
import {__} from "services/i18n";
import {SUBSCRIPTION_TYPES} from "constants.js";

/* istanbul ignore next */
const mapStateToProps = state => ({

});
/* istanbul ignore next */
const mapDispatchToProps = {
    favoritePeopleStart
};

export const PeopleCard = (props) => {
    const {type, item, favoritePeopleStart, color = "light"} = props;

    const goToProfile = useCallback(() => {
        let url = `/people/${item.user_slug}`;
        if(item.company_id) {
            url += `/company/${item.company_id}`;
        }
        historyObject.push(url);
    }, [item]);

    const toggleFavorite = useCallback((event) => {
        favoritePeopleStart({id: item.id, favorite: !item.favorite, type: item.type});
        event.preventDefault();
        event.stopPropagation();
    }, [item, favoritePeopleStart]);

    const skillsRemapped = useMemo(() => {
        if(item.skills.length <= 3) {
            return item.skills;
        }
        return [...item.skills.slice(0, 3), `+${item.skills.length - 3}`];
    }, [item]);


    const renderPlanFlag = useMemo(() => {
        if([SUBSCRIPTION_TYPES.OsaKnight, SUBSCRIPTION_TYPES.OsaKnightExclusive, null].includes(item.plan)) return null;
        return <div className={"flag_type"}><Title size={14}>{__(`common.audace`)}</Title></div>
    }, [item]);


    return <div
        className={`people-card ${type || "vertical"} ${color}`}
        onClick={goToProfile}
    >
        <FavoriteButton favorite={item.favorite} toggleFavorite={toggleFavorite} />
        <div className={`image ${!!item.avatar ? "has-image" : ""}`}>
            {!!item.avatar && <img src={item.avatar} alt={"logo"}/>}
        </div>
        <div className={"data"}>
            <Title size={20} align={"center"}>{item.name}</Title>
            <Text size={12} align={"center"}>{item.text}</Text>
            <div className={"skills"}>
                {skillsRemapped.map(i => <div className="skill" key={i}><Text size={10}>{i}</Text></div> )}
            </div>
        </div>
        {renderPlanFlag}
    </div>
}

PeopleCard.propTypes = {
    type: oneOf(["vertical", "horizontal"]),
    color: oneOf(["light", "dark"])
}
PeopleCard.defaultPropTypes = {
    type: "vertical",
    color: "light"
}

export default connect(mapStateToProps, mapDispatchToProps)(PeopleCard);